import { Dispatch, SetStateAction } from 'react';
import FluentSelect from '@/components/UI/FluentSelect';

type SortMode = 'highToLow' | 'lowToHigh';

const SORT_OPTIONS: { value: SortMode; label: string }[] = [
    { value: 'highToLow', label: 'High to low' },
    { value: 'lowToHigh', label: 'Low to high' },
];

interface Props {
    searchString: string;
    setSearchString: (value: ((prev: string) => string) | string) => void;
    dropdownValue: SortMode;
    setDropdownValue: Dispatch<SetStateAction<SortMode>>;
}

const CaseFilter = ({
    searchString,
    setSearchString,
    dropdownValue,
    setDropdownValue,
}: Props) => {
    return (
        <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
            <FluentSelect<SortMode>
                value={dropdownValue}
                options={SORT_OPTIONS}
                onChange={setDropdownValue}
                minWidth={150}
            />
            <div className="flex items-center bg-layer_2 border border-stroke rounded-fl pl-4 pr-1 focus-within:border-accent focus-within:bg-layer_3 transition-colors flex-1 min-w-[140px] max-w-[280px]">
                <input
                    value={searchString}
                    onChange={(e) => setSearchString(e.target.value)}
                    placeholder="Search…"
                    className="bg-transparent outline-none text-text_main py-2.5 px-2 text-sm w-full min-w-0 placeholder:text-text_4"
                />
                <button
                    type="button"
                    className="w-8 h-8 grid place-items-center text-text_3 hover:bg-layer_3 hover:text-text_main rounded-md transition-colors"
                    aria-label="Search"
                >
                    <svg
                        viewBox="0 0 24 24"
                        className="w-3.5 h-3.5 stroke-current fill-none [stroke-width:2]"
                    >
                        <circle cx="11" cy="11" r="7" />
                        <path d="m21 21-4.3-4.3" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default CaseFilter;
